import {HTMLAttributes} from "react";

export const Container: React.FC<HTMLAttributes<HTMLDivElement>> = (props) => {
  return <div {...props} className={`px-4 sm:px-8 lg:px-10 py-4 sm:py-8 lg:py-10 max-w-screen-2xl mx-auto ${props.className}`}>
    {props.children}
  </div>
}